import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import MultiSelect from '@/components/ui/MultiSelect';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const DAMAGE_RIGHTS_DOCUMENTS_SUBJECT = {
  TOWING_COSTS: 'towing_costs',
  PARKING_COSTS: 'parking_costs',
  STANDING_COSTS: 'standing_costs',
  SUBSTITUTE_VEHICLE: 'substitute_vehicle',
  PERSONAL_INJURY: 'personal_injury',
  OTHER_DAMAGED_PROPERTY: 'other_damaged_property',
  VEHICLE_REPAIR_COSTS: 'vehicle_repair_costs',
} as const;

export const DAMAGE_AOB_LIST_NAME = 'damage_aob_list';

export const DAMAGE_RIGHTS_POA_LIST_NAME = 'damage_rights_poa_list';

export const DAMAGE_RIGHTS_AUTHORIZATIONS_LIST_NAME =
  'damage_rights_authorizations_list';

export const SelectAssignmentOfDamageRightsDocumentsSubject = ({
  name,
  label,
}: {
  name: string;
  label?: string;
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby zakończyć formularz'),
        },
      }}
      defaultValue={[]}
      render={({ field, fieldState }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <MultiSelect
              id={name}
              {...field}
              placeholder={i18n.t('Wybierz')}
              success={fieldState.isDirty && !fieldState.error && field.value}
              data={[
                {
                  label: i18n.t('Koszty holowania'),
                  value: DAMAGE_RIGHTS_DOCUMENTS_SUBJECT.TOWING_COSTS,
                },
                {
                  label: i18n.t('Koszty naprawy pojazdu'),
                  value: DAMAGE_RIGHTS_DOCUMENTS_SUBJECT.VEHICLE_REPAIR_COSTS,
                },
                {
                  label: i18n.t('Koszty postojowe'),
                  value: DAMAGE_RIGHTS_DOCUMENTS_SUBJECT.STANDING_COSTS,
                },
                {
                  label: i18n.t('Koszty parkingu'),
                  value: DAMAGE_RIGHTS_DOCUMENTS_SUBJECT.PARKING_COSTS,
                },
                {
                  label: i18n.t('Pojazd zastępczy'),
                  value: DAMAGE_RIGHTS_DOCUMENTS_SUBJECT.SUBSTITUTE_VEHICLE,
                },
                {
                  label: i18n.t('Szkoda osobowa'),
                  value: DAMAGE_RIGHTS_DOCUMENTS_SUBJECT.PERSONAL_INJURY,
                },
                {
                  label: i18n.t(
                    'Inne uszkodzone mienie (np. fotelik, laptop, telefon)'
                  ),
                  value: DAMAGE_RIGHTS_DOCUMENTS_SUBJECT.OTHER_DAMAGED_PROPERTY,
                },
              ]}
              data-testid="multi-select-assignment-of-damage-rights-documents-subject"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
